module.exports = __webpack_public_path__ + "static/media/teo-logo-light-big.6bbc363f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teo-logo-light-big.png
// module id = 1863
// module chunks = 0